import _objectSpread from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
var __default__ = {
  name: "MessageDetail",
  data: function data() {
    return {
      fiscalYear: moment().add(-3, "month").year(),
      to: "students",
      filterOptions: {
        checkbox: [],
        classroom: false,
        type: false,
        keyword: ""
      },
      message_detail: {
        message: {
          student_sending_count: 0,
          student_opened_count: 0,
          participant_sending_count: 0,
          participant_opened_count: 0
        },
        enquete: {}
      },
      reSendTargets: [],
      checkAllFlag: false,
      showModal: false,
      isLoading: true,
      statuses: [],
      studentStatuses: [],
      participantStatuses: [],
      filteredStatuses: [],
      typeDropDown: [{
        slug: "email",
        label: "メール"
      }, {
        slug: "phone",
        label: "電話"
      }]
    };
  },
  head: {
    title: function title() {
      return {
        inner: "お知らせ配信履歴詳細"
      };
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState(["classrooms", "studentAddress"])), {}, {
    activeClassrooms: function activeClassrooms() {
      var l = this.statuses.map(function (v) {
        return v.class_id;
      }).filter(function (x, i, self) {
        return self.indexOf(x) === i;
      });
      return this.classrooms.filter(function (v) {
        return l.indexOf(v.id) > -1;
      });
    },
    sendTargetsParam: function sendTargetsParam() {
      return this.to === "students" ? {
        students: this.reSendTargets,
        participants: []
      } : {
        students: [],
        participants: this.reSendTargets
      };
    }
  }),
  watch: {
    to: function to() {
      this.filterList();
    }
  },
  created: function created() {
    this.setData();
  },
  methods: {
    setData: function setData() {
      var _this = this;

      getData("reader/get_message_detail/" + this.$route.params.id).then(function (data) {
        _this.message_detail = data.items;
      }).catch(function (error) {
        console.log(error); // axiosのresponseが存在するエラーの時は一覧に戻る
        // if (error.response && this.$route.name !== "messages") {
        //   this.$router.push({ name: "messages" });
        // }
      });
      getData("reader/get_message_statuses/" + this.$route.params.id).then(function (data) {
        if (data) {
          var studentStatuses = data.items.students;
          _this.statuses = _this.studentStatuses = _this.filteredStatuses = studentStatuses;
          _this.participantStatuses = data.items.participants;

          if (studentStatuses && Object.keys(studentStatuses).length === 0 && data.items.participants.length > 0) {
            _this.to = "participants";
          } else {
            _this.to = "students";
          }
        }
      }).catch(function (error) {
        console.log(error); // axiosのresponseが存在するエラーの時は一覧に戻る
        // if (error.response && this.$route.name !== "messages") {
        //   this.$router.push({ name: "messages" });
        // }
      }).then(function () {
        _this.isLoading = false;
      });
    },
    getJPTime: function getJPTime(datetime) {
      return moment(datetime).format("llll");
    },
    getSendStatusJP: function getSendStatusJP(status) {
      var statusJP;

      switch (status) {
        case "error":
          statusJP = "未達";
          break;

        case "reached":
          statusJP = "未開封";
          break;

        case "opened":
          statusJP = "開封済";
          break;
      }

      return statusJP;
    },
    // すべてチェック ON / OFF
    checkAll: function checkAll() {
      if (this.checkAllFlag) {
        if (this.to === "students") {
          this.reSendTargets = this.filteredStatuses.map(function (v) {
            return v.id;
          });
        } else {
          this.reSendTargets = this.filteredStatuses.map(function (v) {
            return v.participant.id;
          });
        }
      } else {
        this.reSendTargets = [];
      }
    },
    // すべてチェック用チェックボックスの監視
    testAllChecked: function testAllChecked() {
      this.checkAllFlag = this.statuses.map(function (v) {
        return v.id;
      }).length === this.reSendTargets.length;
    },
    // リストのフィルタリング
    filterList: function filterList() {
      var _this2 = this;

      var statuses = this.statuses = this.to === "students" ? this.studentStatuses : this.participantStatuses;

      if (this.filterOptions.checkbox.length > 0) {
        if (this.to === "students") {
          statuses = statuses.filter(function (v) {
            return _this2.filterOptions.checkbox.indexOf(v.status) > -1;
          });
        } else {
          statuses = statuses.filter(function (v) {
            return _this2.filterOptions.checkbox.indexOf(v.final_status) > -1;
          });
        }
      }

      if (this.filterOptions.type) {
        if (this.to === "students") {
          statuses = statuses.filter(function (v) {
            return v.guardian.filter(function (w) {
              return w.type === _this2.filterOptions.type;
            }).length > 0;
          });
        } else {
          statuses = statuses.filter(function (v) {
            return v.type === _this2.filterOptions.type;
          });
        }
      }

      if (this.to === "students" && this.filterOptions.classroom) {
        statuses = statuses.filter(function (v) {
          return v.class_id === _this2.filterOptions.classroom;
        });
      }

      if (this.filterOptions.keyword !== "") {
        statuses = statuses.filter(function (v) {
          return v.name.indexOf(_this2.filterOptions.keyword) > -1 || v.ruby.indexOf(_this2.filterOptions.keyword) > -1 || v.guardian.findIndex(function (v2) {
            return v2.name.indexOf(_this2.filterOptions.keyword) > -1;
          }) > -1 || v.guardian.findIndex(function (v2) {
            return v2.ruby.indexOf(_this2.filterOptions.keyword) > -1;
          }) > -1;
        });
      }

      this.filteredStatuses = statuses;
    },
    handleTo: function handleTo(val) {
      this.to = val;
    },
    downloadCSV: function downloadCSV() {
      var _this3 = this;

      var csvArray = [];

      if (this.to === "students") {
        csvArray = [["No", "クラス", this.studentAddress + "氏名", "ステータス", "保護者1氏名", "保護者1開封種別", "保護者1ステータス", "保護者1開封日時", "保護者2氏名", "保護者2開封種別", "保護者2ステータス", "保護者2開封日時", "保護者3氏名", "保護者3開封種別", "保護者3ステータス", "保護者3開封日時"]];
        this.filteredStatuses.forEach(function (v, i) {
          var row = [i + 1, v.classroom_name, v.name, _this3.getSendStatusJP(v.status)];
          v.guardian.forEach(function (v2) {
            row = row.concat([v2.name, v2.type === "email" ? "メール" : "電話", _this3.getSendStatusJP(v2.status), v2.status === "opened" ? _this3.getJPTime(v2.status_timestamps.updated_at) : ""]);
          }); // 保護者が3人以下の場合には空配列で列数を揃える

          if (row.length < 16) {
            row = row.concat(new Array(16 - row.length));
          }

          csvArray.push(row);
        });
      } else {
        csvArray = [["No", "氏名", "所属など", "種別", "ステータス", "開封日時"]];
        this.filteredStatuses.forEach(function (v, i) {
          var row = [i + 1, v.participant.name, v.participant.belonging, v.type === "email" ? "メール" : "電話", _this3.getSendStatusJP(v.final_status), v.final_status === "opened" ? _this3.getJPTime(v.updated_at) : ""];
          csvArray.push(row);
        });
      }

      var bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      saveAs(new Blob([bom, Papa.unparse(csvArray)], {
        type: "text/csv;charset=utf-8"
      }), this.message_detail.content.subject + "_お知らせ配信状況.csv");
    }
  }
};
import moment from "moment";
import { getData } from "@/services/axios";
import { mapState } from "vuex";
import RowItem from "../RowItem";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import StatusRate from "./StatusRate.vue";
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props) {
    return {
      __sfc: true,
      RowItem: RowItem,
      StatusRate: StatusRate
    };
  }
});